import { useEffect, useState } from 'react'
//import reload from '../../Imgs/svg/ReLoad.svg'

import { Button } from 'antd'
import { motion } from 'framer-motion'
import { api } from '../../api/index'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import CaptchaGenerator from '../../Components/CaptchaGenerator'

//Media
import emailUserIcon from '../../Imgs/svg/IconMail.svg'
import userIcon from '../../Imgs/svg/faceUser.svg'
import mapPinIcon from '../../Imgs/svg/location.svg'
import phoneIcon from '../../Imgs/svg/phone.svg'
// const workUs = `${IMAGE_BUCKET}/backgroud-workus.webp`
import workUs from '../../../src/Imgs/newIcons/WorkWeUsWomenWithGlasses.jpg'

// const workUs =
//   "https://pideypasa-s3.s3.amazonaws.com/Images/webpage/work-us.webp";

function WorkUs() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  function handleInputChange(event) {
    const property = event.target.name //  se guarda el nombre de la propiedad que queremos modificar
    const value = event.target.value // con este valor la vamos a modificar
    setErrors({ ...errors, [event.target.name]: false })

    setDataInputs({ ...dataInputs, [property]: value }) // usamos Brackect notation para poder acceder a la propiedad correcta y setear el valor
  }

  const [dataInputs, setDataInputs] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    location: '',
    resume: ''
  })

  const [base64Data, setBase64Data] = useState(null)
  const [errors, setErrors] = useState({})

  const handleFileChange2 = (event) => {
    const file = event.target.files[0]

    if (file) {
      const reader = new FileReader()
      reader.onload = () => {
        const base64 = reader.result
        setBase64Data(base64)
        setDataInputs({ ...dataInputs, resume: base64Data })
      }
      reader.readAsDataURL(file)
    }
  }

  const _sentFromRegister = async () => {
    const newErrors = {}

    // Validar si hay campos vacíos
    for (let key in dataInputs) {
      if (dataInputs[key] === '') {
        newErrors[key] = true
      }
    }

    // Si hay errores, establecer el estado de errores y detener el envío del formulario
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      // console.log(errors)
      // return
    } else {
      const { name, email, phone, message, location, resume } = dataInputs
      const requestData = {
        name,
        email,
        phone,
        message,
        location,
        resume,
        base64Data
      }
      await api.postWorkWithUs(requestData)
      setDataInputs({
        name: '',
        email: '',
        phone: '',
        message: '',
        location: '',
        resume: ''
      })
      setBase64Data(null)
    }
  }

  const [aceptPolicities, setAceptPolicities] = useState(false)
  const [captchaCheck, setCaptchaCheck] = useState(false)

  const [file] = useState()

  return (
    <>
      <div
        className="md:pb-0 grid grid-cols-1 md:grid-cols-3 gap-4 md:pt-0 px-2 md:px-16 bg-no-repeat bg-center h-[20rem] md:h-[35rem]"
        style={{
          backgroundImage: `url(${workUs})`,
          //height: "40rem",
          backgroundSize: 'cover'
        }}
      />
      <div className="flex justify-center">
        <div className="container ">
          <div>
            <ToastContainer />

            <motion.div
              initial={{ x: -400 }}
              transition={{ duration: 1.2 }}
              animate={{ x: 0 }}
              className="p-10"
            >
              <h1 className="text-center text-2xl  md:text-justify md:text-5xl mb-10 font-bold">
                Trabaja con nosotros
              </h1>
              <p className="text-base  md:text-xl text-justify">
                Juntos llegamos más lejos! Déjanos tus datos y tu curriculum
                vitáe para tenerte en cuenta en nuestras convocatorías.
              </p>
            </motion.div>

            <motion.form
              initial={{ x: -400 }}
              transition={{ duration: 1.2 }}
              animate={{ x: 0 }}
              className="mt-4 w-[80%] lg:w-[60%] mx-auto lg:mx-0"
              method="POST"
              onSubmit={(event) => {
                event.preventDefault()

                _sentFromRegister()
                // submitForm();
              }}
            >
              <div className="flex-col justify-center">
                <div className="flex flex-col lg:flex-row lg:space-x-12 lg:ml-[4%] w-full">
                  <div className="basis-1/2">
                    <div className="relative">
                      <div className="absolute left-3">
                        <img
                          height="30"
                          width="30"
                          src={userIcon}
                          alt="userIcon"
                          className="mt-4"
                        />
                      </div>
                      <input
                        className={`p-4 pl-12 bg-gray-100 w-full rounded  ${
                          errors.name ? 'border-red-600 border' : 'border-none'
                        } mb-5`}
                        type="text"
                        placeholder="Nombre y Apellido"
                        name="name"
                        value={dataInputs.name}
                        onChange={handleInputChange}
                      />
                      {/* {errors.name && (
                  <span className="error-label">
                    Te falta este campo: Nombre
                  </span>
                )} */}
                    </div>
                  </div>
                  <div className="basis-1/2">
                    <div className="relative">
                      <div className="absolute left-3">
                        <img
                          height="30"
                          width="30"
                          src={mapPinIcon}
                          alt="mapPinIcon"
                          className="mt-4"
                        />
                      </div>
                      <input
                        className={`p-4 pl-12 bg-gray-100 w-full rounded  ${
                          errors.location
                            ? 'border-red-600 border'
                            : 'border-none'
                        } mb-5`}
                        type="text"
                        placeholder="Ciudad"
                        name="location"
                        value={dataInputs.location}
                        onChange={handleInputChange}
                      />
                      {/* {errors.location && (
                  <span className="error-label">
                    Te falta este campo: Ciudad
                  </span>
                )} */}
                    </div>
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row lg:space-x-12 lg:ml-[4%] w-full">
                  <div className="basis-1/2">
                    <div className="relative">
                      <div className="absolute left-3">
                        <img
                          height="30"
                          width="30"
                          src={emailUserIcon}
                          alt="emailUserIcon"
                          className="mt-4"
                        />
                      </div>
                      <input
                        className={`p-4 pl-12 bg-gray-100 w-full rounded  ${
                          errors.email ? 'border-red-600 border' : 'border-none'
                        } mb-5`}
                        type="text"
                        placeholder="Email"
                        name="email"
                        value={dataInputs.email}
                        onChange={handleInputChange}
                      />
                      {/* {errors.email && (
                  <span className="error-label">
                    Te falta este campo: Email
                  </span>
                )} */}
                    </div>
                  </div>
                  <div className="basis-1/2">
                    <div className="relative">
                      <div className="absolute left-3">
                        <img
                          height="30"
                          width="30"
                          src={phoneIcon}
                          alt="phoneIcon"
                          className="mt-4"
                        />
                      </div>
                      <input
                        className={`p-4 pl-12 bg-gray-100 w-full rounded  ${
                          errors.phone ? 'border-red-600 border' : 'border-none'
                        } mb-5`}
                        type="text"
                        placeholder="Celular"
                        name="phone"
                        value={dataInputs.phone}
                        onChange={handleInputChange}
                      />
                      {/* {errors.phone && (
                  <span className="error-label">
                    Te falta este campo: Celular
                  </span>
                )} */}
                    </div>
                  </div>
                </div>
                .
                <textarea
                  className={`p-4 h-32 bg-gray-100 rounded mb-5 lg:ml-[4%] w-full ${
                    errors.message ? 'border-red-600 border' : 'border-none'
                  } mb-5`}
                  style={{ resize: 'none' }}
                  placeholder="Escribe tu mensaje"
                  name="message"
                  value={dataInputs.message}
                  onChange={handleInputChange}
                />
              </div>

              <div className="text-center flex flex-col lg:flex-row lg:ml-[4%]">
                <label
                  htmlFor="file"
                  className="py-3 px-12 bg-Main text-white rounded"
                >
                  Adjuntar
                </label>
                <input
                  name="resume"
                  id="file"
                  type="file"
                  className="hidden"
                  accept=".pdf"
                  //value={file}
                  // onChange={handleFileChange}
                  onChange={handleFileChange2}
                />

                <p className="my-auto ml-6 mt-4">Cargar PDF hasta 3MB</p>
                {/* {errors.resume && (
            <span className="error-label">
              Te falta este campo: curriculum vitae
            </span>
          )} */}
              </div>

              <div className="flex">
                <p className="my-auto ml-6">{file && file.name}</p>
              </div>

              <div className="mt-4 flex it lg:ml-[4%]">
                <input
                  onClick={() => {
                    if (aceptPolicities === false) setAceptPolicities(true)
                    if (captchaCheck === true) setCaptchaCheck(false)
                  }}
                  type="checkbox"
                  id="cbox2"
                />
                <label htmlFor="cbox2" className="ml-4 text-justify">
                  Acepto el tratamiento que Tecnicall Colombia S.A.S le dará a
                  mis datos personales, de acuerdo con la política de
                  privacidad, las cuales he leído previamente.
                </label>
              </div>

              <div className="flex flex-col lg:flex-row lg:ml-[4%] mt-12 mb-5 space-x-4">
                <CaptchaGenerator setCaptchaCheck={setCaptchaCheck} />
              </div>

              <div className="mt-2 flex lg:ml-[4%] mb-12">
                <Button
                  onClick={() => {
                    _sentFromRegister()
                  }}
                  type="submit"
                  className={`${
                    aceptPolicities && captchaCheck
                      ? 'bg-Main h-[60px] w-[200px]'
                      : 'bg-slate-400 h-[60px] w-[200px]'
                  } p-[10px] w-[150px] rounded-xl`}
                >
                  <p className="text-xl  text-white rounded">Enviar</p>
                </Button>
              </div>
            </motion.form>
          </div>
        </div>
      </div>
    </>
  )
}

export default WorkUs
